import * as React from 'react'
import styled, { css } from 'styled-components'

const Animator = styled.div`
  -webkit-animation: scale-up-center 2s cubic-bezier(0.39, 0.575, 0.565, 1) infinite alternate both;
  animation: scale-up-center 2s cubic-bezier(0.39, 0.575, 0.565, 1) infinite alternate both;
  @-webkit-keyframes scale-up-center {
    0% {
      -webkit-transform: scale(0.7);
      transform: scale(0.7);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  @keyframes scale-up-center {
    0% {
      -webkit-transform: scale(0.7);
      transform: scale(0.7);
    }
    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }

  width: 10px;
  height: 10px;
  min-width: 10px;
  min-height: 10px;
  border-radius: 20px;
  background-color: #72cf5b;
`
const OnlineIcon = () => {
  return <Animator />
}

export default OnlineIcon
